import BaseTableRows from "./BaseTableRows";
import { getRollingCacheConfig } from "./CachedIGImg";

const TableStandings = ({ data, isRolling = false }) => (
  <table className="text-center font-bold italic">
    <thead>
      <tr className="border-b">
        <th colSpan="3" />
        <th className="px-4">GP</th>
        <th className="bg-green-600 px-4">W</th>
        <th className="bg-gray-500 px-4">D</th>
        <th className="bg-red-500 px-4">L</th>
        <th className="px-6">:</th>
        <th className="px-6">PTS</th>
        <th className="border-x px-4 text-sm">PIM</th>
      </tr>
    </thead>
    <tbody>
      {data.map((team, index) => (
        <tr key={index}>
          <BaseTableRows
            index={team.originalIndex !== undefined ? team.originalIndex : index}
            icon={team.Logo}
            name={team.Name}
            nameClassName={index < 1 && "!font-bold"}
            cacheConfig={getRollingCacheConfig(isRolling)}
          />
          <td className="">{team.Z}</td>
          <td className="text-green-600">{team.V}</td>
          <td className="text-gray-500">{team.R}</td>
          <td className="text-red-500">{team.P}</td>
          <td className="text-sm">{team.Score}</td>
          <td>{team.B}</td>
          <td className="border-x">{team.TM}</td>
        </tr>
      ))}
    </tbody>
  </table>
);

export default TableStandings;
